var _jsxFileName = "/repo/packages/ippm/src/components/Disclaimer/index.js";
import React from 'react';
import { sanitizeString } from '@sm/utils';
import { Typography } from '@sm/wds-react';
import { useAppContext } from '../../utils/appContext';
import { PLAN_TYPES } from '../../constants/plans';
export default function Disclaimer() {
  var _this = this;
  var _useAppContext = useAppContext(),
    overageCostInfo = _useAppContext.overageCostInfo,
    displayedPlanType = _useAppContext.displayedPlanType,
    getString = _useAppContext.getString;
  var individualDisclaimers = function individualDisclaimers() {
    var overageCostHtml = overageCostInfo !== null && overageCostInfo !== void 0 && overageCostInfo.has_overage_cost ? overageCostInfo.overage_cost : '';
    var responses = getString('responses_per_month').replace('{overageCostHtml}', overageCostHtml);
    return overageCostInfo !== null && overageCostInfo !== void 0 && overageCostInfo.has_overage_cost ? /*#__PURE__*/React.createElement("aside", {
      className: "disclaimer wds-m-l-6 wds-p-b-4",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      variant: "bodySm",
      color: "dark-muted",
      dangerouslySetInnerHTML: {
        __html: sanitizeString(responses)
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 11
      }
    })) : null;
  };
  var teamsDisclaimers = function teamsDisclaimers() {
    return /*#__PURE__*/React.createElement("aside", {
      className: "disclaimer wds-m-l-6 wds-p-b-4",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      variant: "bodySm",
      color: "dark-muted",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 9
      }
    }, getString('display_pricing_represents')), /*#__PURE__*/React.createElement(Typography, {
      component: "p",
      variant: "bodySm",
      color: "dark-muted",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 9
      }
    }, getString('add_on_features')));
  };
  return displayedPlanType === PLAN_TYPES.INDIVIDUAL ? individualDisclaimers() : teamsDisclaimers();
}